import { useState } from "react";
import "./meetingdetails.css";
import Header from "./Header";
import Detailssection from "./Detailssection";
import momsection from "../../assets/notch_mom_yellow.png";
import MomDrawer from "./Meetingdrawer";
import Actionstate from "./Actionstate";
import Hexapi from "../../utility/HexAPI/Hexapi";
import MeetingQRScanner from "./MeetingQRScanner";
import { showConfirm } from "../../utility/showconfirm";
import { Modal, Spinner } from "react-bootstrap";
import Loader from "../../components/loader/Loader";
import { RSVP } from "./Rsvp";


const Meetingdetails = ({
  userid,
  setisInfo,
  meetingInfo,
  meetingAction,
  attachments,
  GetMeetingDetails,
  getMeetingListData
}) => {
  const [showMom, setShowMom] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [loading, setLoading] = useState(false);

 
  const executeQuery = async (query, queryArr, successCallback) => {
    try {
      setLoading(true);
      const resp = await Hexapi({ query, queryArr });
      if (resp?.[""]?.[0]?.command === 1) {
        successCallback?.();
      } else if (resp?.[""]?.[0]?.command === 0) {
        showConfirm({ content: resp?.[""]?.[0]?.msg, hideCancel: false });
      }
    } catch (err) {
      console.error("API error:", err);
      showConfirm({ content: "Something went wrong. Please try again.", hideCancel: true });
    } finally {
      setLoading(false);
    }
  };


  const handleQRJoin = async (MeetingQR) => {
    if (!MeetingQR) return;
    setShowScanner(false);

    let meetingData;
    try {
      meetingData = atob(MeetingQR);
    } catch (err) {
      await showConfirm({
        content:`Invalid QR Code:, ${err}`
      })
     
      return;
    }

    const query = `HRApp_Droid_Proc_User_Meeting_Join @UserID='{0}',@MeetingQR='{1}'`;
    await executeQuery(query, [userid, meetingData], () => {
      GetMeetingDetails(true);
      getMeetingListData(true);
    });
  };


  const handleMeetingAction = async (query, queryArr, type) => {
    switch (type) {
      case "REQUEST_START_MEETING":
      case "REQUEST_END_MEETING":
      case "REQUEST_LEAVE_MEETING":
        await executeQuery(query, queryArr, () => {
          GetMeetingDetails(true);
          getMeetingListData(true);
        });
        break;

      case "REQUEST_JOIN_MEETING":
        setShowScanner(true);
        break;

      default:
        console.warn("Unknown action type:", type);
    }
  };

  return (
    <div className="meetingdetails">
      <div className="meetingdetailinfo" style={{ position: "relative" }}>
        <Header info={meetingInfo} onClick={() => setisInfo(true)} />

        {loading && (
          <Modal show={loading} centered>
            <Modal.Body>
             <Loader/>
            </Modal.Body>
          </Modal>
          
        )}

        {meetingAction?.length > 0 && (
          <Detailssection
            userID={userid}
            meetingInfo={meetingInfo}
            details={meetingAction}
          />
        )}

        {meetingInfo?.mom && (
          <div className="momsection" onClick={() => setShowMom(true)}>
            <img src={momsection} className="img-fluid" alt="MOM Section" />
          </div>
        )}
{
  (  meetingInfo?.joined !== 1 ) && <RSVP GetMeetingDetails={GetMeetingDetails} meetingID={meetingInfo?.meetingid} userID={userid} curRSVPAction={meetingInfo?.currsvpaction}/>
}

        <Actionstate
          meetingInfo={meetingInfo}
          userID={userid}
          onActionClick={handleMeetingAction}
        />

        <MomDrawer
          attachments={attachments}
          showMom={showMom}
          setShowMom={setShowMom}
          mominfo={meetingInfo}
          userid={userid}
          GetMeetingDetails={GetMeetingDetails}
        />

        {showScanner && (
          <MeetingQRScanner
            userid={userid}
            show={showScanner}
            onJoin={handleQRJoin}
            onClose={() => setShowScanner(false)}
          />
        )}


            
      </div>
    </div>
  );
};

export default Meetingdetails;